var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFamily = function SvgFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 131 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 101c29.271 0 53-1.12 53-2.5S82.271 96 53 96 0 97.12 0 98.5s23.729 2.5 53 2.5Z",
    fill: "#249241"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#family_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m101.524 96.007-5.122.01 2.078-8.62 5.122-.011-2.078 8.62Z",
    fill: "#F3B9A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.657 94.448 6.873-.017s.117 1.466 2.295 1.685c2.178.219 3.378 1.346 3.556 2.867l-13.624.032s.106-1.805.906-4.567h-.006Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.381 98.99-13.624.03.002.957 13.624-.03-.002-.958Z",
    fill: "#002335"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.178 95.88a.305.305 0 0 0-.009-.61v.305-.306h-.008l-.011.001a.714.714 0 0 0-.116.014 1.775 1.775 0 0 0-.291.083c-.244.09-.589.262-1.033.591a.305.305 0 1 0 .363.49c.405-.3.699-.441.881-.509.092-.033.155-.048.19-.055l.033-.005h.001",
    fill: "#002335"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.34 95.984a.305.305 0 0 1-.286.322h-.001l-.017-.305.017.305h.001-.003l-.018.002a1.802 1.802 0 0 0-.354.08c-.222.074-.477.209-.665.447a.305.305 0 1 1-.479-.376 2.01 2.01 0 0 1 .95-.65 2.428 2.428 0 0 1 .518-.111h.01l.004-.001h.002l.017.304-.017-.304c.168-.01.312.12.321.287Zm-.286.322",
    fill: "#002335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.708 36.404 9.034 22.531a8.638 8.638 0 0 1 .3 5.126l-5.495 27.559-9.623-.126 4.578-29.216-9.329-27.384 10.535 1.51Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.001 96.029-5.123.01.095-8.615 5.122-.01-.094 8.615Z",
    fill: "#F3B9A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.134 94.475 6.873-.016s.116 1.466 2.294 1.685c2.178.218 3.379 1.345 3.556 2.866l-13.623.033s.105-1.805.905-4.568h-.005Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.858 99.013-13.624.03.002.957 13.624-.03-.002-.957Z",
    fill: "#002335"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m84.56 96.989.03-.304.029-.303h.011l.026.004c.022.002.052.007.091.013a4.35 4.35 0 0 1 1.272.402c.704.355 1.461 1.028 1.464 2.236l-.61.001c-.002-.892-.54-1.396-1.129-1.692a3.742 3.742 0 0 0-1.163-.355l-.018-.002h-.004ZM92.649 95.901a.305.305 0 0 0-.009-.61v.306-.305h-.019a.59.59 0 0 0-.116.014 1.768 1.768 0 0 0-.29.083c-.245.09-.59.262-1.034.591a.305.305 0 0 0 .363.49c.405-.3.7-.442.881-.509a1.17 1.17 0 0 1 .223-.06Z",
    fill: "#002335"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.817 96.006a.305.305 0 0 1-.287.322l-.018-.305.017.305h.001-.003l-.017.002a1.79 1.79 0 0 0-.353.08c-.223.074-.479.209-.666.447a.305.305 0 0 1-.48-.377c.285-.363.66-.551.95-.649a2.405 2.405 0 0 1 .518-.111h.01l.004-.001h.001l.018.304-.017-.304c.169-.01.313.12.322.287Zm-.287.322Z",
    fill: "#002335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.857 34.878-3.74 56.616-9.511-.192.266-45.189c.056-3.276 1.123-4.923 3.062-7.587l1.522-2.095 8.401-1.553Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m96.533 45.729 2.727-3.85-.416-.294-2.807 3.961-.578 6.343.508.046.566-6.206Z",
    fill: "#002335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.413 17.187c1.556-.372 3.15.449 3.728 1.915l5.562 14.102c.589 1.488-.05 3.173-1.478 3.922-1.695.886-3.795.115-4.489-1.646l-5.54-14.108c-.694-1.767.35-3.736 2.223-4.185h-.006Z",
    fill: "#8CB3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.656 17.215-4.078.65-1.294 4.678 4.172 12.351 12.224-.027 1.706-12.871-1.562-4.896-2.41-.154-8.758.269Z",
    fill: "#8CB3DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m102.692 22.752-1.272 8.567-.613-.092 1.272-8.566.613.091Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.705 34.869-12.252.027.004 1.532 12.251-.028-.003-1.531Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.426 46.65-.561 1.646-1.05.903a1.403 1.403 0 0 0-.362 1.668l.128.268 5.951-3.342-1.7-2.484-2.401 1.34h-.005Z",
    fill: "#BBCCD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.576 47.815-6 3.375-.25-.432c-.045-.072-.017-.165.055-.208l5.867-3.299.328.564Z",
    fill: "#566C77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.076 32.039s0 .136.016.394c.084 1.684.612 8.462 3.251 13.484l-3.406 1.023s-4.562-4.885-4.59-12.21l.578-3.08 4.145.389h.006Z",
    fill: "#1A5CA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.691 46.365-1.428.875-1.328.038a1.372 1.372 0 0 0-1.294 1.013l-.072.273 6.439 1.083.272-2.839-2.589-.443Z",
    fill: "#BBCCD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.03 49.696-6.495-1.094.078-.465a.149.149 0 0 1 .167-.12l6.35 1.072-.105.607",
    fill: "#566C77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.009 30.978-4.228 16.432-3.879-1.04s1.623-12.526 3.29-15.442c.589-1.034 4.817.044 4.817.044v.006Z",
    fill: "#1A5CA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.148 14.988c-.089.088-.567.203-1.028.296a.798.798 0 0 1-.962-.728l-.566-5.875c-.084-1.761 1.555-3.25 3.344-3.386l2.045-.219c1.717-.13 4.084 1.122 4.234 2.812l-7.067 7.1Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.609 17.723h-.167c-2.433.044-4.439-1.87-4.478-4.266l-.078-4.902a1.137 1.137 0 0 1 1.123-1.143l5.8-.093a2.027 2.027 0 0 1 2.073 1.975l.066 4.015c.039 2.396-1.9 4.37-4.339 4.409v.005Z",
    fill: "#DE906F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.531 12.27a.359.359 0 0 1-.383.333.358.358 0 0 1-.339-.377.359.359 0 0 1 .383-.334c.2.011.35.18.339.378ZM114.92 12.22a.359.359 0 0 1-.383.334.358.358 0 0 1-.339-.377.359.359 0 0 1 .383-.334c.2.01.351.18.339.377Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.555 12.738a.205.205 0 0 1 .225.184l.078.76a.207.207 0 0 1-.194.225l-.422.022a.205.205 0 0 1-.021-.41l.207-.01-.056-.546a.204.204 0 0 1 .183-.225Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.315 14.386c-.067.033-3.139.126-3.139.126s.216 1.023 1.572 1.018c1.445 0 1.567-1.143 1.567-1.143Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.892 10.404c.123.033.239.033.35.039.112 0 .223 0 .317.005.189.022.411.115.645.18.044.017.089-.021.094-.076.006-.033 0-.071-.022-.093a1.418 1.418 0 0 0-.306-.295 1.028 1.028 0 0 0-.377-.17.95.95 0 0 0-.395.022.923.923 0 0 0-.35.191c-.039.033-.044.104-.017.148a.096.096 0 0 0 .05.044h.006l.005.005ZM112.059 10.136a1.516 1.516 0 0 0-.545-.208 1.515 1.515 0 0 0-.566 0c-.2.033-.378.12-.55.22-.173.103-.334.229-.478.388-.034.038-.039.109-.011.158.022.038.055.055.083.044.344-.12.683-.263 1-.306.161-.022.339-.017.511-.028.173-.01.35-.01.528-.049.045-.01.078-.066.067-.131a.103.103 0 0 0-.05-.088h.011Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.231 12.379s2.789-.29 2.222-4.272l6.762-.219a1.796 1.796 0 0 0-1.845-1.575l-3.145.087c-2.517.071-4.433 2.254-4.139 4.72l.15 1.259h-.005Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.964 12.75c.017.903-.717 1.647-1.633 1.658-.917.017-1.673-.705-1.684-1.608-.017-.902.717-1.647 1.634-1.657.916-.017 1.672.705 1.683 1.608ZM126.466 27.044l-2.933-1.996-1.917 1.242 3.495 2.275 1.355-1.52Z",
    fill: "#DE906F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.927 28.521s-.289.58.606 1.461a6.45 6.45 0 0 0 1.172.897 1.215 1.215 0 0 0 1.467-.159l.994-.99a1.166 1.166 0 0 0 .062-1.619c-.634-.711-1.934-1.269-3.156-1.16l-1.145 1.57Z",
    fill: "#DE906F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.305 27.86a1.487 1.487 0 0 1 1.756.087l1.795 1.471a.387.387 0 0 1 .05.547.393.393 0 0 1-.517.077l-3.228-2.084.144-.093v-.005Z",
    fill: "#DE906F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.737 18.877s7.168 3.704 10.901 7.68l-2.017 3.168-8.923-5.552c-.117-.12.039-5.296.039-5.296Z",
    fill: "#7F939D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.176 18.407s-3.039-.388-5.306-.777c-2.267-.388-6.94 1.04-6.94 1.04l1.561 3.862c-.422 1.307-.572 3.178-.761 4.387-.272 1.778-.155 3.134.384 4.037-.095.673-.128 1.192-.061 1.444.338 1.264 7.884.071 9.301.197 1.416.126 3.205-11.066 3.411-12.784.083-.711-1.589-1.411-1.589-1.411v.005Z",
    fill: "#7F939D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.37 16.947h3.261c.106 0 .195.082.195.191v.892c0 .99-.817 1.794-1.823 1.794-1.005 0-1.822-.804-1.822-1.794v-.892c0-.104.083-.192.194-.192h-.005Z",
    fill: "#DE906F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.39 17.838c-3.145-.18-5.335 3.02-3.979 5.82 1.345 2.768 3.423 6.543 6.623 11.504 1.217 1.882 3.728 2.495 5.7 1.39 1.857-1.04 3.785-1.018 2.99-2.965l-7.912-13.56a4.143 4.143 0 0 0-3.428-2.189h.005Z",
    fill: "#8CB3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.442 30.403 4.967-3.544a.662.662 0 0 1 .828.043c.261.23.294.618.078.892l-1.078 1.34 3.783.35a.702.702 0 0 1 .562 1.001l-1.2 2.467a.724.724 0 0 1-.512.389c-1.55.284-5.728 1.597-7.995.284l.561-3.216.006-.006Z",
    fill: "#F3B9A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.39 37.082 14.124-1.548-1.3-6.624-13.83.53c-1.872.28-3.278 2.763-3.06 4.617.227 1.97 2.077 3.348 4.066 3.03v-.005Z",
    fill: "#8CB3DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m95.413 29.006-4.783-8.2-.536.312 4.974 8.527 8.544-.426-.031-.619-8.168.406Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m92.373 29.125 2.855-.11.024.62-2.856.11-.023-.62Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.947 13.5s-1.867-2.445-2.123-6.203c-.15-2.16-1.85-5.103-4.489-6.094-.022-.005.45-.279.428-.29-.89-.42-2.395-.092-3.434-.076-4.89.087-7.35 3.687-7.345 7.193.006 3.67 2.84 5.695 5.256 6.482l-.017.099s.173.016.462.038c.677.18 1.3.268 1.8.257a5.01 5.01 0 0 0 1.05-.137c2.717.033 6.428-.153 8.412-1.269Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.646 7.997c-.05.958.672 1.778 1.611 1.833.945.055 1.934-.684 1.99-1.641.05-.957-.673-1.778-1.612-1.833-.944-.054-1.933.684-1.989 1.647v-.006Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.802 12.543.055 4.152c.022 1.46-.85 2.248-2.267 2.254-1.206 0-2.539-.558-2.5-1.844l.228-6.542 4.49 1.98h-.006Z",
    fill: "#F3B9A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.846 15.114-4.595-2.86c.105-1.242 4.55-.137 4.55-.137l.045 2.997Z",
    fill: "#DE906F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.485 13.342c2.411-.022 4.567-1.51 4.561-4.305l-.011-3.436c.056-2.51-1.855-4.61-4.317-4.753-2.522-.148-5.817 1.81-5.956 4.376l.678 3.244c-.017 2.937 2.161 4.71 5.045 4.874Z",
    fill: "#F3B9A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.374 7.954a.205.205 0 0 1 .236.169l.138.853a.205.205 0 0 1-.19.238l-.595.033a.205.205 0 1 1-.023-.41l.367-.02-.102-.628a.205.205 0 0 1 .17-.235Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.274 7.363c0 .235.178.427.406.432a.421.421 0 0 0 .016-.842.421.421 0 0 0-.422.41ZM94.468 7.292c0 .235.178.426.406.432a.418.418 0 0 0 .422-.41.423.423 0 0 0-.406-.433.421.421 0 0 0-.422.41Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.846 9.88-3.4-.012s.483 1.198 1.911 1.214c1.172.017 1.495-1.203 1.495-1.203h-.006Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.874 5.727c.156.028.306.028.45.033h.411c.245.016.534.11.834.175h.005a.111.111 0 0 0 .128-.077c.005-.032 0-.07-.028-.093a1.554 1.554 0 0 0-.394-.29 1.512 1.512 0 0 0-.49-.164 1.436 1.436 0 0 0-.51.028 1.24 1.24 0 0 0-.456.197.1.1 0 0 0-.022.147.11.11 0 0 0 .066.044h.011-.005ZM95.73 5.465a2.475 2.475 0 0 0-.706-.203 2.743 2.743 0 0 0-.734 0c-.255.039-.489.12-.71.225-.223.11-.434.23-.629.394a.117.117 0 0 0-.016.158c.027.038.072.05.11.038.445-.125.884-.268 1.3-.317.212-.022.44-.022.662-.033.228-.01.456-.016.69-.049.055-.01.1-.066.088-.131 0-.038-.028-.071-.061-.088l.005.006Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.89 8.172.639-1.006c.139-.908-.033-1.718-.24-2.155-.238-.504-.21-1.291.668-1.937 1.294-.951 3.945-1.646 6.29-.716a2.681 2.681 0 0 1 1.483 1.411c.122.29.222.596.228.875l-.011-.629C99.901 1.641 97.901-.06 95.49 0c-.844.022-1.81-.06-2.878.126-2.7.476-4.761 2.97-3.939 5.547l.85 1.728 1.367.771Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.867 8.418c-.05.952.845 1.756 1.784 1.811.933.055 1.733-.673 1.783-1.625.05-.951-1.033-1.75-1.967-1.805-.933-.054-1.55.668-1.6 1.62Z",
    fill: "#F3B9A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m90.503 9.098-.195.03.195-.03a.205.205 0 0 1-.405.064V9.16l-.001-.008a1.512 1.512 0 0 0-.227-.54.936.936 0 0 0-.369-.322c-.157-.074-.366-.113-.65-.064a.205.205 0 0 1-.068-.404c.356-.061.651-.016.892.097.24.112.41.284.532.458a1.869 1.869 0 0 1 .293.699l.002.014.001.005v.002Zm-.405.064Zm0 0 .203-.032-.203.031Zm0 0",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.957 3.069s.678-.389 1.878.115c2.495 1.039 5.467.218 5.106-.952l-3.145-.936-3.634.47-.205 1.308V3.07Z",
    fill: "#053249"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "family_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(82)",
    d: "M0 0h49v100H0z"
  })))));
};
export default SvgFamily;